import React, { Component } from 'react';
import ProjectPage from '../../components/ProjectPage';
import Table from '../../components/Table';
import Banner from '../../images/projects/HalloweenNightmareBanner.jpg'

class HalloweenNightmare extends Component {
  render() {
    return (
    <ProjectPage title="Halloween Nightmare" banner={Banner}>

        <div className='project-page-part'>

          <Table className="centered" data={{
            Status : "Finished",
            Type : "School project",
            Engine : "Unreal Engine 5",
            Language : "Bluprints",
            Duration : "3 weeks",
            Team : "Group of 3",
            Date : "2022"
          }}/>

        </div>

        <div className='project-page-part'>

          <h3>Context :</h3>

          <p className='basic-text'>
            The objective of this project was to discover Unreal Engine and the blueprint system by creating a game from scratch.
          </p>

        </div>

        <div className='project-page-part'>

          <h3>Game :</h3>

          <p className='basic-text'>
            Halloween Nightmare is a Third Person game where you play 3 different characters with different abilities through 3 levels and a final boss level where you can freely switch between the characters in order to beat the boss.
          </p>

        </div>

        <div className='project-page-part'>

          <h3>My contribution :</h3>

          <ul className="basic-text">
            <li>Global ability system</li>
            <li>Enemy AI</li>
            <li>3rd Playable Character</li>
            <li>3rd Map</li>
            <li>Final Boss</li>
          </ul>

        </div>
    </ProjectPage>
    );
  }
}

export default HalloweenNightmare;